import SlsWebLogger from "js-sls-logger";
import request from "@/utils/request.js";
import { getUserInfo } from "@/utils/common.js";
//说明，阿里云日志埋点分为三大块，分别是数据埋点，数据行为和数据心跳，（目前不做数据行为）
const host = "cn-beijing.log.aliyuncs.com";
const source = "WEB_APP_TMP_H5";
//注意，用户 id 和 openid 应该是实时获取，不应该定义在这里。
let isReleaseEnv =
  "production" === process.env.NODE_ENV &&
  undefined === process.env.VUE_APP_MODE;

//数据埋点
const dataGatherProject = isReleaseEnv ? "jkhh-log-web" : "jkhh-log-test";
const dataGatherLogstore = isReleaseEnv ? "jkhh-h5-log" : "jkhh-test-log";
const dataGather__topic__ = "tmp-app-h5";
const opts = {
  host,
  project: dataGatherProject,
  logstore: dataGatherLogstore,
  time: 10,
  count: 10
};
const logger = new SlsWebLogger(opts);

//心跳
const heartbeatProject = isReleaseEnv ? "web-heartbeat-log" : "jkhh-test-log";
const heartbeatHost = host;
const heartbeatLogstore = heartbeatProject;

//行为
// const actionProject = isReleaseEnv ? "web-action-log" : "jkhh-test-log";
// const actionHost = host;
// const actionLogstore = actionProject;

/**
 * 阿里日志埋点Api
 * @param params
 * @param project
 * @param host
 * @param logstore
 * @returns {AxiosPromise}
 */
const buriedPointApi = (params, project, host, logstore) => {
  return request({
    closeLoading: true,
    closeAllIntercept: true,
    url: `https://${project}.${host}/logstores/${logstore}/track`,
    method: "get",
    params: params
  });
};

//埋点
export function dataGather(
  page = "",
  event = "",
  properties = "",
  version = ""
) {
  if (!isReleaseEnv) {
    if (!page) {
      console.warn("埋点页面编号不能为空");
      return;
    }
    if (!event) {
      console.warn("埋点事件编号不能为空");
      return;
    }
  }
  let data = {
    __topic__: dataGather__topic__, //不要修改，统计用
    APIVersion: "0.6.0",
    userId: getUserInfo("id") || "0",
    openId: getUserInfo("h5OpenId") || "",
    pageName: window.PAGE_PATH,
    eventTime: new Date().getTime(),
    screenHeight: document.documentElement.clientHeight,
    screenWidth: document.documentElement.clientWidth,
    page: page,
    event: event,
    properties: properties !== "" ? JSON.stringify(properties) : "",
    version
  };
  logger.send(data);
}

//心跳
export function heartbeat(rate) {
  let data = {
    __topic__: "web_heartbeat_log",
    __source__: source,
    APIVersion: "0.6.0",
    userId: getUserInfo("id") || "0",
    openId: getUserInfo("h5OpenId") || "",
    eventTime: new Date().getTime(),
    pageName: window.PAGE_PATH,
    rate: rate,
    screenHeight: document.documentElement.clientHeight,
    screenWidth: document.documentElement.clientWidth
  };
  buriedPointApi(data, heartbeatProject, heartbeatHost, heartbeatLogstore)
    .then(() => {})
    .catch(() => {});
}

export function setHeartbeat(rate = 5) {
  setInterval(() => {
    heartbeat(rate);
  }, rate * 1000);
}
